(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-brand-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ln-brand-header').forEach(function (header) {
    var toggle = header.querySelector('.ln-brand-header__menu-toggle');
    var menu = header.querySelector('.ln-brand-header__mobile-menu');
    if (!toggle || !menu || toggle.dataset.bound) return;
    toggle.dataset.bound = 'true';
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? '打开导航菜单' : '关闭导航菜单');
      menu.hidden = open;
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) { toggle.setAttribute('aria-expanded', 'false'); menu.hidden = true; }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-us-warehouse-network"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.Shopify && window.Shopify.designMode) return;

    const sections = document.querySelectorAll('.ln-us-network');
    if (!sections.length) return;

    const animateCount = (el) => {
      if (el.dataset.lnDone === 'true') return;
      el.dataset.lnDone = 'true';
      const target = Number(el.dataset.lnCount || 0);
      el.textContent = '0';
      const duration = 1200;
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased);
        if (progress < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('[data-ln-count]').forEach(animateCount);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-warehouse-node-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initWarehouseSwitcher = (root) => {
      const tabs = [...root.querySelectorAll('[data-ln-warehouse-tab]')];
      const panels = [...root.querySelectorAll('[data-ln-warehouse-panel]')];
      if (!tabs.length || !panels.length) return;

      const activate = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel, panelIndex) => {
          panel.classList.toggle('is-active', panelIndex === index);
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activate(Number(tab.dataset.lnWarehouseTab || 0));
        });
      });
    };

    document.querySelectorAll('[data-ln-warehouse-section]').forEach(initWarehouseSwitcher);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-ln-warehouse-section]');
      if (root) initWarehouseSwitcher(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
